export default "__VITE_ASSET__BkSflUNZ__"